import { c as _c } from "react/compiler-runtime";
import { domAnimation, LazyMotion } from "motion/react";

/**
 * A provider component that enables motion animations for its children.
 */
function MotionProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <LazyMotion features={domAnimation}>{children}</LazyMotion>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export { MotionProvider };